import React from "react";

// Minimal inline **bold** / *italic* renderer — used by KeyboardShortcutsView.js, whose content
// only needs two inline styles (no tables/code/links), so a small hand-rolled formatter is
// enough there. Anything needing full GFM markdown (tables, code spans, blockquotes) goes
// through MarkdownContent.js (react-markdown + remark-gfm) instead.
export function renderInlineMarkdown(text) {
  const parts = [];
  const regex = /\*\*(.+?)\*\*|\*(.+?)\*/g;
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    if (match[1] !== undefined) parts.push(<strong key={key++}>{match[1]}</strong>);
    else parts.push(<em key={key++}>{match[2]}</em>);
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}
